var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MapControl',{attrs:{"center":_vm.getCenter(),"scale":6,"markers":_vm.getMarkers()}})
}
var staticRenderFns = []

export { render, staticRenderFns }